// extracted by mini-css-extract-plugin
module.exports = {"loader":"DocsPermissionChoicePage_loader__2ZEXh"};